class FwVimeoPlayer extends HTMLElement {
    videoId;
    videoPoster;
    videoTitle;
    openInFancybox;
    playerInstance;

    #hasKlaro;
    #klaroManager;

    constructor() {
        super();
    }

    connectedCallback() {
        this.videoId = this.getAttribute('video-id');
        this.videoPoster = this.getAttribute('video-poster');
        this.videoTitle = this.getAttribute('video-title');
        this.openInFancybox = this.getAttribute('open-in-fancybox') === 'true';

        // check if klaro is available
        this.#hasKlaro = window.klaro !== undefined;
        if (this.#hasKlaro) {
            this.#klaroManager = window.klaro.getManager();
        }

        this.render();
        this.addEventListeners();
    }

    render() {
        this.innerHTML = `
            <button aria-label="${(this.videoTitle ? `${this.videoTitle} abspielen` : 'Video abspielen')}">
                ${
                    this.videoPoster
                    ? this.createPlaceholder(this.videoId, this.videoPoster)
                    : this.createPlaceholder(this.videoId, false)
                }
            </button>
        `;
    }

    createPlaceholder(id, posterUrl) {
        const placeholderUrl = posterUrl || `/includes/futureweb/vimeoThumbnailWrapper.php?videoId=${id}`;

        return `
            <div class="fw-vimeo-player-placeholder">
                <img src="${placeholderUrl}" role="presentation">
                <div class="fw-vimeo-player-placeholder-play"></div>
            </div>
        `;
    }
    addEventListeners() {
        const button = this.querySelector('button');
        button.addEventListener('click', () => {
            this.onButtonClick();
        });
    }
    onButtonClick() {
        const hasConsented = this.#hasKlaro ? this.#klaroManager.consents.vimeo : true;

        if (this.openInFancybox) {
            hasConsented ? this.createFancybox() : this.createPopup({ fancybox: true });
        } else {
            hasConsented ? this.createIframe() : this.createPopup({ fancybox: false });
        }
    }
    createPopup(options) {
        const defaultStrings = {
            de: {
                title: "Zustimmung erforderlich",
                text: "Damit Sie dieses Video ansehen können, müssen Sie der<br />Verwendung von <b>Vimeo</b> zustimmen.",
                accept: "Zustimmen",
                decline: "Ablehnen",
            },
            en: {
                title: "Permission required",
                text: "This website uses <b>Vimeo</b> to provide video contents.<br/> If you want to continue, you have to allow the usage otherwise we are unable to provide the contents of this video.",
                accept: "Accept",
                decline: "Decline",
            },
        };
        const htmllang = document.documentElement.lang.toLowerCase();
        const isSupportedLanguage = Object.keys(defaultStrings).indexOf(htmllang) !== -1;
        const lang = isSupportedLanguage ? htmllang : "en";

        const klaroElem = document.querySelector("#klaro .klaro");

        if (!klaroElem) {
            document.createElement("div");
            klaroElem.className = "klaro";
        }

        klaroElem.innerHTML = `
            <div class="cookie-modal">
                <div class="cm-bg"></div>
                <div class="cm-modal cm-klaro">
                    <div class="cm-header">
                        <h1 class="title"><span>${defaultStrings[lang].title}</span></h1>
                        <p>${defaultStrings[lang].text}</p>
                    </div>
                    <div class="cm-footer">
                        <div class="cm-footer-buttons">
                            <button class="cm-btn cm-btn-decline" type="button">${defaultStrings[lang].decline}</button>
                            <button class="cm-btn cm-btn-success" type="button">${defaultStrings[lang].accept}</button>
                        </div>
                    </div>
                </div>
            </div>
        `;

        const klaroElemAccept = klaroElem.querySelector(".cm-btn.cm-btn-success");
        const klaroElemDecline = klaroElem.querySelector(".cm-btn.cm-btn-decline");

        klaroElemAccept.addEventListener("click", () => {
            options.fancybox ? this.createFancybox() : this.createIframe();
            if (this.#hasKlaro) {
                this.#klaroManager.updateConsent('vimeo', true);
                this.#klaroManager.saveAndApplyConsents();
            }
            this.destroyPopup();
        });
        klaroElemDecline.addEventListener("click", () => {
            if (this.#hasKlaro) {
                this.#klaroManager.updateConsent('vimeo', false);
                this.#klaroManager.saveAndApplyConsents();
            }
            this.destroyPopup();
        });
    }
    destroyPopup() {
        const klaroElem = document.querySelector("#klaro .klaro");
        klaroElem.innerHTML = "";
    }
    createIframe() {
        this.loadScriptByURL('vimeo-iframe-sdk', 'https://player.vimeo.com/api/player.js', () => {
            const iframe = document.createElement("div");
            const button = this.querySelector("button");

            iframe.className = "vimeo-player-elem";

            // replace element with iframe
            this.replaceChild(iframe, button);

            // init player via JS
            const player = new window.Vimeo.Player(iframe, {
                id: this.videoId
            });

            // on player loaded
            player.on("loaded", () => {
                // add player instance to parent elem
                this.playerInstance = player;
                this.classList.remove("loading");
                this.classList.add("player-ready");

                // trigger event on ready
                var readyEvent = new Event("player.ready");
                this.dispatchEvent(readyEvent);

                // play video
                player.play();
            });
        });
    }
    createFancybox() {
        window.Fancybox.show([
            {
                src: `https://vimeo.com/${this.videoId}`,
                type: "video",
                id: "fw-vimeo-popup",
                ratio: 16 / 9,
                videoAutoplay: true,
            }
        ])
    }

    loadScriptByURL(id, url, callback) {
        const isScriptExist = document.getElementById(id);

        if (!isScriptExist) {
            var script = document.createElement("script");
            script.type = "text/javascript";
            script.src = url;
            script.id = id;
            script.onload = function () {
                if (callback) callback();
            };
            document.body.appendChild(script);
        }

        if (isScriptExist && callback) callback();
    }
}

customElements.define('fw-vimeo-player', FwVimeoPlayer);